import React from "react";

interface SplitSectionProps {
  id?: string;
  eyebrow: React.ReactNode;
  heading: React.ReactNode;
  body: React.ReactNode;
  visual: React.ReactNode;
}

/**
 * Two-column section: a visual (screenshot, schematic, or pending-capture frame) beside
 * prose copy. The visual renders first on desktop and drops below the copy on mobile.
 */
const SplitSection: React.FC<SplitSectionProps> = ({ id, eyebrow, heading, body, visual }) => {
  return (
    <section id={id} className="cs-section cs-split">
      <div className="cs-split-inner">
        <div className="cs-split-visual">{visual}</div>
        <div className="cs-split-copy">
          <div className="eyebrow">{eyebrow}</div>
          <h2>{heading}</h2>
          <div className="cs-split-body">{body}</div>
        </div>
      </div>
    </section>
  );
};

export default SplitSection;
